import classNames from 'classnames'
import { FC } from 'react'
import styles from './analysisGoalPicker.module.scss'

// The facility's category, framed as what the reviews are for. Same values as
// the other modules' campaign categories; the backend sets the AI summary's
// voice from it.
const GOALS: { description: string; icon: FC; value: string }[] = [
  {
    description: 'Monitor your own reputation and customer sentiment',
    icon: () => (
      <svg fill="none" viewBox="0 0 24 24">
        <path
          d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8Z"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth="1.6"
        />
        <circle cx="7.5" cy="7.5" fill="currentColor" r="1.3" />
      </svg>
    ),
    value: 'Brand Management',
  },
  {
    description: 'Benchmark your reviews against rival businesses',
    icon: () => (
      <svg fill="none" viewBox="0 0 24 24">
        <path
          d="M4 20h16M6 20V11h3v9M10.5 20V5h3v15M15 20v-7h3v7"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth="1.6"
        />
      </svg>
    ),
    value: 'Competitor Analysis',
  },
  {
    description: 'Explore trends and expectations across a market',
    icon: () => (
      <svg fill="none" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.6" />
        <path
          d="M3 12h18M12 3c2.5 2.6 3.8 5.6 3.8 9s-1.3 6.4-3.8 9c-2.5-2.6-3.8-5.6-3.8-9S9.5 5.6 12 3Z"
          stroke="currentColor"
          strokeWidth="1.6"
        />
      </svg>
    ),
    value: 'Market Research',
  },
]

interface AnalysisGoalPickerProps {
  // Cards in a column (a narrow modal) instead of a row of three.
  compact?: boolean
  onChange: (goal: string) => void
  // '' = none chosen yet
  value: string
}

export const AnalysisGoalPicker: FC<AnalysisGoalPickerProps> = ({
  compact = false,
  onChange,
  value,
}) => (
  <div className={styles.wrapper}>
    <p className={styles.label}>Analysis Goal</p>
    <p className={styles.subtitle}>
      What do you want to learn from these reviews? Choose one
    </p>
    <div
      className={classNames(styles.cards, compact && styles.cardsCompact)}
      role="radiogroup"
    >
      {GOALS.map((goal) => {
        const on = goal.value === value
        const Icon = goal.icon
        return (
          <button
            aria-checked={on}
            className={classNames(styles.card, on && styles.cardOn)}
            key={goal.value}
            onClick={() => onChange(goal.value)}
            role="radio"
            type="button"
          >
            <span className={styles.icon}>
              <Icon />
            </span>
            <span className={styles.text}>
              <span className={styles.title}>{goal.value}</span>
              <span className={styles.description}>{goal.description}</span>
            </span>
            <span className={classNames(styles.radio, on && styles.radioOn)} />
          </button>
        )
      })}
    </div>
  </div>
)
